import { defineAnalytics } from '@zg-rentals/rentals-analytics';
import { tracker as CLICKSTREAM, type ClickstreamPayload } from '@zg-rentals/clickstream';
import { tracker as COMSCORE } from '@zg-rentals/comscore';
import type { ZrmUserInfo } from '@zg-rentals/clickstream';

export const analytics = defineAnalytics({ COMSCORE, CLICKSTREAM });
export const trackComscoreEvent = analytics.createTrackEvent('COMSCORE');
export const trackUserEvent = analytics.createTrackEvent<'CLICKSTREAM', ClickstreamPayload<ZrmUserInfo>>('CLICKSTREAM');
